import { render, staticRenderFns } from "./PracticeChapterStart.vue?vue&type=template&id=6edd6a21&scoped=true"
import script from "./PracticeChapterStart.vue?vue&type=script&lang=js"
export * from "./PracticeChapterStart.vue?vue&type=script&lang=js"
import style0 from "./PracticeChapterStart.vue?vue&type=style&index=0&id=6edd6a21&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6edd6a21",
  null
  
)

export default component.exports